import { styled, VariantProps } from "@phntms/css-components";
import {
  LeftChevronIcon,
  RightChevronIcon,
  LeftChevronWhiteIcon,
  RightChevronWhiteIcon,
} from "@itchannelplus/assets/icons";
import { ButtonHTMLAttributes } from "react";
import styles from "./styles.module.scss";

const PreviousButtonContainer = styled("button", {
  css: [styles.ctrlButton, styles.previous, "previous-btn"],
  variants: {
    autoHide: {
      true: [styles.autoHide],
    },
    autoHideMobile: {
      true: [styles.autoHide, styles.autoHideMobile],
    },
    position: {
      around: [styles.around, "around-btn"],
      inside: [styles.inside, "inside-btn"],
    },
  },
  defaultVariants: {
    position: "around",
  },
});

const NextButtonContainer = styled("button", {
  css: [styles.ctrlButton, styles.next, "next-btn"],
  variants: {
    autoHide: {
      true: [styles.autoHide],
    },
    autoHideMobile: {
      true: [styles.autoHide, styles.autoHideMobile],
    },
    position: {
      around: [styles.around, "around-btn"],
      inside: [styles.inside, "inside-btn"],
    },
  },
  defaultVariants: {
    position: "around",
  },
});

export const PreviousButton = ({
  theme = "dark",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof PreviousButtonContainer> & {
    theme?: "light" | "dark";
  }) => {
  const IconComponent =
    theme === "light" ? LeftChevronWhiteIcon : LeftChevronIcon;
  return (
    <PreviousButtonContainer {...props}>
      <IconComponent width={15} height={28} />
    </PreviousButtonContainer>
  );
};

export const NextButton = ({
  theme = "dark",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof NextButtonContainer> & { theme?: "light" | "dark" }) => {
  const IconComponent =
    theme === "light" ? RightChevronWhiteIcon : RightChevronIcon;
  return (
    <NextButtonContainer {...props}>
      <IconComponent width={15} height={28} />
    </NextButtonContainer>
  );
};
